
// Set up IntersectionObserver to toggle sticky class dynamically
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const stickyEl = entry.target;

        if (!stickyEl) return;

        if (entry.intersectionRatio === 0) {
            stickyEl.classList.add('is-sticky');
        } else if (entry.intersectionRatio === 1) {
            stickyEl.classList.remove('is-sticky');
        }
    });
}, { threshold: [0, 1] });

// Observe all sentinels with [data-track-sticky-state]
document.querySelectorAll('[data-track-sticky-state]').forEach(sentinel => {
    observer.observe(sentinel);
});



class ResponsiveReadMore {
    constructor(selector = '[data-read-more]', debounceDelay = 150) {
        this.selector = selector;
        this.debounceDelay = debounceDelay;
        this.elements = [];
        this.resizeHandler = this.debounce(this.onResize.bind(this), this.debounceDelay);
        this.init();
    }

    init() {
        this.elements = Array.from(document.querySelectorAll(this.selector));
        this.elements.forEach((el) => {
            const config = this.parseConfig(el.dataset.readMore);
            if (!config) return;

            el.__readMoreState = {
                config,
                button: null,
                originalMaxHeight: null
            };

            this.applyTruncation(el);
        });

        window.addEventListener('resize', this.resizeHandler);
    }

    parseConfig(raw) {
        try {
            const parsed = JSON.parse(raw);
            const { mobile, tablet, desktop } = parsed;
            if ([mobile, tablet, desktop].some((v) => typeof v !== 'number')) return null;
            return { mobile, tablet, desktop };
        } catch (e) {
            console.warn('[ReadMore] Invalid config:', raw);
            return null;
        }
    }

    getBreakpoint() {
        const width = window.innerWidth;
        if (width < 768) return 'mobile';
        if (width < 1024) return 'tablet';
        return 'desktop';
    }

    getLineHeight(el) {
        const style = window.getComputedStyle(el);
        let lh = parseFloat(style.lineHeight);
        if (isNaN(lh) || style.lineHeight === 'normal') {
            lh = 1.2 * parseFloat(style.fontSize);
        }
        return lh;
    }

    applyTruncation(el) {
        const state = el.__readMoreState;
        if (!state) return;

        const lines = state.config[this.getBreakpoint()];
        const lineHeight = this.getLineHeight(el);
        const maxHeight = lines * lineHeight;

        el.style.maxHeight = 'none';
        el.style.overflow = 'visible';

        const realHeight = el.scrollHeight;
        console.log({
            el,
            realHeight,
            maxHeight,
            shouldTruncate: realHeight > maxHeight * 1.05
        });
        if (realHeight <= maxHeight * 1.05) return;

        el.classList.add('read-more-content');
        el.style.maxHeight = `${maxHeight - 10}px`;
        el.style.overflow = 'hidden';
        el.style.transition = 'max-height 0.3s ease-in-out';
        el.setAttribute('aria-expanded', 'false');

        this.addToggleButton(el, maxHeight);
    }

    addToggleButton(el, maxHeight) {
        const state = el.__readMoreState;
        if (state.button) {
            state.button.remove();
        }

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'read-more-toggle semibold link';
        btn.textContent = window.themeVariables?.strings?.accessibilityReadMore || 'Read more';

        btn.addEventListener('click', () => {
            const expanded = el.getAttribute('aria-expanded') === 'true';
            el.style.maxHeight = expanded ? `${maxHeight - 10}px` : 'none';
            el.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            btn.textContent = expanded
                ? window.themeVariables?.strings?.accessibilityReadMore || 'Read more'
                : window.themeVariables?.strings?.accessibilityReadLess || 'Read less';
        });

        el.after(btn);
        state.button = btn;
    }

    onResize() {
        this.elements.forEach((el) => {
            const state = el.__readMoreState;
            if (!state) return;

            el.style.maxHeight = 'none';
            el.style.overflow = 'visible';
            el.removeAttribute('aria-expanded');
            if (state.button) state.button.remove();
            this.applyTruncation(el);
        });
    }

    debounce(fn, delay) {
        let timer = null;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }
}

window.addEventListener('DOMContentLoaded', () => {
    new ResponsiveReadMore();
});
